import deepCopy from 'lib/deepCopy';
import {FromServerNote} from 'notebook/util/NoteUtilConstants';

export default function deepCopyNote<T extends FromServerNote>(noteJson?: T | null): T | undefined | null {
  if (noteJson == null) {
    return noteJson;
  }

  // VersionedItemSubstore.prepareForStore mutates `note` and each `notePart`, but direct return values
  // from GraphQL cannot be mutated, so this translator makes a deep copy of the Note so it can be mutated.
  return deepCopy(noteJson);
}
